import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "@azure/core-http";
/**
 * Credential policy used to sign HTTP(S) requests before sending. This is an
 * abstract class.
 */

export var CredentialPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(CredentialPolicy, _BaseRequestPolicy);

  var _super = _createSuper(CredentialPolicy);

  function CredentialPolicy() {
    _classCallCheck(this, CredentialPolicy);

    return _super.apply(this, arguments);
  }

  _createClass(CredentialPolicy, [{
    key: "sendRequest",
    value:
    /**
     * Sends out request.
     *
     * @param request -
     */
    function sendRequest(request) {
      return this._nextPolicy.sendRequest(this.signRequest(request));
    }
    /**
     * Child classes must implement this method with request signing. This method
     * will be executed in {@link sendRequest}.
     *
     * @param request -
     */

  }, {
    key: "signRequest",
    value: function signRequest(request) {
      // Child classes must override this method with request signing. This method
      // will be executed in sendRequest().
      return request;
    }
  }]);

  return CredentialPolicy;
}(BaseRequestPolicy);